import React from 'react';

export function Textarea({
  label,
  error,
  helperText,
  maxLength,
  value = '',
  id,
  required,
  className = '',
  rows = 4,
  ...props
}) {
  const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
  const charCount = value?.length || 0;
  const isNearLimit = maxLength && charCount >= maxLength * 0.8;

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label htmlFor={textareaId} className="block text-small text-foreground">
          {label}
          {required && <span className="text-muted ml-1">*</span>}
        </label>
      )}
      <textarea
        id={textareaId}
        required={required}
        value={value}
        maxLength={maxLength}
        rows={rows}
        className={`
          w-full px-4 py-3 bg-secondary border text-foreground text-body
          placeholder:text-muted focus:outline-none focus:border-foreground
          transition-colors duration-normal resize-none
          ${error ? 'border-red-500' : 'border-border'}
        `}
        {...props}
      />
      <div className="flex justify-between">
        {(error || helperText) && (
          <p className={`text-caption ${error ? 'text-red-400' : 'text-muted'}`}>
            {error || helperText}
          </p>
        )}
        {maxLength && (
          <p className={`text-caption ml-auto ${isNearLimit ? 'text-subtle' : 'text-muted'}`}>
            {charCount}/{maxLength}
          </p>
        )}
      </div>
    </div>
  );
}

export default Textarea;
